export default __webpack_public_path__ + "static/media/scramble.bd53b52f.svg";